import { http } from '../../../plugins/axios'

const actions = {
  get ({commit}, payload) {
    let url = 'permission?perPage=-1&page=1'
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getUsers ({commit}, payload) {
    let url = 'user'
    
    let params = {
      "perPage": payload.event.perPage,
      "page": payload.event.page,
      "sortKey": payload.event.sortKey ? payload.event.sortKey : 'id',
      "ord": payload.event.ord,
      "find": payload.event.find ? payload.event.find : undefined,
    }
    let options = {
      emulateJSON: false
    }
    http.get(url, { params: params}, options)
      .then(
        response => {
          commit('onGetUsers', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getUserById ({commit}, payload) {
    let url = `user/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetUserById', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  post ({commit}, payload) {
    let url = `permission/${payload.event.item.id}`
    let params = {
      "permissions": payload.event.item.permissions
    }
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  }
}

export default actions